// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__ms1nA","name":"ConsentHeader_name__2tm97","birthday":"ConsentHeader_birthday__3uukj","skeleton":"ConsentHeader_skeleton__2JvrI"};